import { GS3HeaderLogo } from "@/assets/images";

export const LoadingSpinner = () => {
  return (
    <div className="flex flex-col items-center">
      <img
        src={GS3HeaderLogo}
        alt="Loading..."
        className="w-[75px] animate-waveOpacity mb-6"
      />
      <style>{`
        @keyframes waveOpacity {
          0% { opacity: 1; }
          50% { opacity: 0.5; }
          100% { opacity: 1; }
        }
        .animate-waveOpacity {
          animation: waveOpacity 2.5s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};
